import { profile, axiosConfig } from 'api';
import { AxiosRequestConfig } from 'axios';

import { Response } from 'models/response';

export interface CreateCorporateEmailRequest {
  email: string;
}

export interface CreateCorporateEmailResponse {
  id: string;
}

export interface SetCountryRequest {
  countryId: string;
}

export interface SetCompanyRequest {
  companyName: string;
  document: string;
  issuer: string;
  issuerDate: Date | null;
}

export interface SetCompanyAdminRequest {
  userName: string;
  userLastName: string;
  userPhoneNumber: string;
}

export interface CreateCompanyRequest
  extends CreateCorporateEmailRequest,
    SetCountryRequest,
    SetCompanyRequest,
    SetCompanyAdminRequest {
  id?: string;
}

export interface LinkRappiUserRequest {
  email: string;
  token: string;
}
export interface VerifyLinkedRappiUserParameters {
  email: string;
}

export type VerifyLinkedRappiUserResponse = 'NoUser' | 'UserLikendWithRappi' | 'UserNotLinkedWithRappi';

export interface SendEmailRequest {
  email: string;
  name: string;
  subject: string;
  message: string;
}

export const createEmail = (data: CreateCorporateEmailRequest): Promise<Response<CreateCorporateEmailResponse>> =>
  profile
    .post<Response<CreateCorporateEmailResponse>>('/Onboarding/CreateCorporateEmail', data, axiosConfig)
    .then((response) => response.data);

export const setCountry = (data: SetCountryRequest, id: string): Promise<Response<any>> =>
  profile
    .put<Response<any>>(`/Onboarding/SetCountry/${id}`, data, axiosConfig)
    .then((response) => response.data)
    .catch((error) => error.data);

export const setCompany = (data: SetCompanyRequest, id: string): Promise<Response<any>> =>
  profile.put<Response<any>>(`/Onboarding/SetCompany/${id}`, data, axiosConfig).then((response) => response.data);

export const setCompanyAdmin = (data: SetCompanyAdminRequest, id: string): Promise<Response<any>> =>
  profile
    .put<Response<any>>(`/Onboarding/SetCompanyAdmin/${id}`, data, axiosConfig)
    .then((response) => response.data)
    .catch((error) => error.data);

export const createCompany = (data: CreateCompanyRequest): Promise<Response<any>> =>
  profile
    .post<Response<any>>('/Onboarding/CreateCompanyOnboarding', data, axiosConfig)
    .then((response) => response.data);

export const linkRappiUser = (data: LinkRappiUserRequest): Promise<Response<any>> =>
  profile
    .put<Response<any>>('/Users/LinkRappiUser', data, { ...axiosConfig, noAuth: true } as AxiosRequestConfig)
    .then((response) => response.data)
    .catch((error) => error.response.data);

export const verifyLinkedRappiUser = (
  params: VerifyLinkedRappiUserParameters,
): Promise<Response<VerifyLinkedRappiUserResponse>> =>
  profile
    .get<Response<VerifyLinkedRappiUserResponse>>(`/Users/VerifyLinkedRappiUser/${params.email}`, axiosConfig)
    .then((response) => response.data)
    .catch((error) => error.data);

export const sendSupportEmail = (data: SendEmailRequest) => profile.post<Response<void>>('/Email', data);
